<template>
	<div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-space-y-4">
		<h2 class="tw-text-xl tw-font-semibold">
			<span v-html="t('rc.inactive_title')"></span>
		</h2>
		<div class="tw-flex tw-items-center tw-text-lg tw-text-center tw-p-2">
			<font-awesome-icon
				class="tw-mr-2"
				icon="triangle-exclamation"
				:style="{
					color: 'orange',
				}" />
			<span v-html="t(rcInactiveReason)"></span>
		</div>
	</div>
</template>
<script setup lang="ts">
import { useTranslation } from "i18next-vue";

const { t } = useTranslation();
defineProps({
	rcInactiveReason: {
		type: String,
		default: "",
	},
});
</script>